module.exports = {
    min_char: 'At least {amount} characters!'
}